import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AdminStatsTable from './dashboard/AdminStatsTable';

const AdminStatsPage = () => {
  const { selectedDevice, appUser } = useSelector((state) => state.appreducer);
  const navigate = useNavigate();

  useEffect(() => {
    if (appUser && appUser.user_type !== 'SUPER_ADMIN' && appUser.user_type !== 'ORG_ADMIN') {
      navigate('/device-info');
    }
  }, [appUser]);

  return (
    <>
      <Grid item xs={12} sm={12} md={8} lg={6}>
        <AdminStatsTable></AdminStatsTable>
      </Grid>
    </>
  );
};

export default AdminStatsPage;
